import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { appAuthenticator } from '@futrli/shared-services';
import { createCurrentUserQueryGuard, refreshCurrentUserData } from '@futrli/views/queries/currentUser';
import {
  setCurrentAuthenticatedUserFulfilled,
  setCurrentAuthenticatedUserPending,
  updateCurrentAuthenticatedUser
} from '@futrli/auth/auth/redux-utils/actions';

export const useRefreshCurrentUser = () => {
  const dispatch = useDispatch();

  const refreshCurrentUser = useCallback(
    async (quiet = false) => {
      // Get updated user data from backend
      const request = refreshCurrentUserData();
      const isCurrent = createCurrentUserQueryGuard();
      const newCurrentUser = await request;
      if (!isCurrent()) {
        return;
      }

      // Set loading flag in redux if quiet = false
      if (!quiet) {
        dispatch(setCurrentAuthenticatedUserPending());
      }

      // Get merged user data (merges API data with data from auth system, e.g: Auth0)
      const user = await appAuthenticator.getCurrentAuthenticatedUser(newCurrentUser);
      if (!isCurrent()) {
        return;
      }

      // Update redux with newest merged user data
      if (quiet) {
        dispatch(updateCurrentAuthenticatedUser(user));
      } else {
        dispatch(setCurrentAuthenticatedUserFulfilled(user));
      }
    },
    [dispatch]
  );

  return {
    refreshCurrentUser
  };
};
